import env from "../env";
// 腾讯视频
var packageConfig = {
  iphone: {
    packageName: 'com.tencent.live4iphone',
    packageUrl: 'tenvideo2://?action=4&tabIndex=0',
    download: 'itms-apps://itunes.apple.com/cn/app/id458318329?mt=8'
  },
  ipad: {
    packageName: 'com.tencent.QQLiveHD',
    packageUrl: 'tenvideo2://?action=4&tabIndex=0',
    download: 'itms-apps://itunes.apple.com/cn/app/id407925512?mt=8'
  },
  aphone: {
    packageName: 'com.tencent.qqlive',
    packageUrl: 'tenvideo2://?action=4&tabIndex=0',
    download: 'https://mcgi.v.qq.com/commdatav2?cmd=4&confid=87&platform=aphone'
  }
};
export default packageConfig[env.device] || packageConfig.aphone;